import Pair from 'app/common/pair'
import { downloadFile, post } from '../baseService'
import { OutputType } from 'app/constants/outputType'

const create = (): any => {
  const getOutputType = (outputType: OutputType) => {
    return outputType === OutputType.Pdf ? 'application/pdf' : 'application/csv'
  }

  const getOutputFile = (id: string) =>
    downloadFile(
      `/config-api/importTask/downloadOutputFile?id=${id}`,
      {},
      true,
      'application/octet-stream',
    )

  const getPdf = (
    companyId,
    reportType,
    drivers,
    vehicles,
    startTime,
    endTime,
    outputType: OutputType,
    id,
    data: any = {},
  ) => {
    const payload = {
      id,
      drivers: drivers ? drivers.map((d) => +d) : null,
      vehicles: vehicles ? vehicles.map((d) => +d) : null,
      reportType,
      startTime: startTime,
      endTime: endTime,
      outputType,
      data,
    }

   

    return post(
      `print-api/${companyId}/printout/print`,
      payload,
      false,
    )
  }

  const getPdfFromDates = (
    companyId,
    reportType,
    drivers,
    vehicles,
    dates,
    outputType: OutputType,
    id,
    data: any = {},
  ) => {
    const payload = {
      id,
      drivers: drivers ? drivers.map((d) => +d) : null,
      vehicles: vehicles ? vehicles.map((d) => +d) : null,
      reportType,
      dates,
      outputType,
      data,
    }
    return post(
      `print-api/${companyId}/printout/print`,
      payload,
      false,
    )
  }

  const getActiveDriversReport = (
    companies,
    groups,
    months,
    year,
    outputType: OutputType,
    showDetails,
    showActiveness,
    showTimesheet,
    showBusinessTrip,
    showPrintout,
    showBasic,
    showPRO,
    showVPN,
    showUpdater,
    showCurrentlyActive,
  ) =>
    downloadFile(
      `config-api/printout/activeDrivers`,
      {
        companies,
        groups,
        months,
        year,
        csv: outputType == OutputType.Csv,
        showDetails,
        showActiveness,
        showTimesheet,
        showBusinessTrip,
        showPrintout,
        showBasic,
        showPRO,
        showVPN,
        showUpdater,
        showCurrentlyActive,
      },
      true,
      getOutputType(outputType),
    )

  const getAuditReport = (
    companies,
    groups,
    user,
    startDate,
    endDate,
    events,
    outputType: OutputType,
    sortBy: number,
  ) =>
    downloadFile(
      `config-api/printout/audit`,
      {
        companies,
        groups,
        user,
        startDate,
        endDate,
        events,
        csv: outputType == OutputType.Csv,
        sortBy,
      },
      true,
      getOutputType(outputType),
    )

  const getSynchronizationReport = (
    companies,
    user,
    startDate,
    endDate,
    outputType: OutputType,
    sortBy: number,
    onlyUpdater: boolean,
  ) =>
    downloadFile(
      `config-api/printout/synchronization`,
      {
        companies,
        user,
        startDate,
        endDate,
        csv: outputType == OutputType.Csv,
        sortBy,
        onlyUpdater,
      },
      true,
      getOutputType(outputType),
    )

  const getDemoReport = (
    startDate,
    endDate,
    outputType: OutputType,
    sortBy: number,
  ) =>
    downloadFile(
      `config-api/printout/demo`,
      {
        startDate,
        endDate,
        csv: outputType == OutputType.Csv,
        sortBy,
      },
      true,
      getOutputType(outputType),
    )

  const getRealIncomeReport = (companies, period) =>
    downloadFile(
      `config-api/printout/realIncome`,
      {
        companies,
        period,
      },
      true,
      getOutputType(OutputType.Csv),
    )

  const getCompanyDataReport = (
    companies,
    groups,
    months,
    year,
    outputType: OutputType,
    sortBy: number,
    onlyPro: boolean,
    onlyPackage: boolean,
    mergeSameCompanies: boolean,
    source: number,
    updatePaymentDate: boolean,
  ) =>
    downloadFile(
      `config-api/printout/companyData`,
      {
        companies,
        groups,
        months,
        year,
        csv: outputType == OutputType.Csv,
        sortBy,
        onlyPro,
        onlyPackage,
        mergeSameCompanies,
        source,
        updatePaymentDate,
      },
      true,
      getOutputType(outputType),
    )

  const getTimesheetReport = (companies: Array<Pair<string, string>>, period) =>
    downloadFile(
      `config-api/printout/timesheet`,
      {
        companies: companies.map((c) => `${c.key}|${c.value}`),
        period,
        csv: true,
      },
      true,
      getOutputType(OutputType.Csv),
    )

  const getTimesheetDetailedReport = (
    companies: Array<Pair<string, string>>,
    period,
    detailed: boolean,
  ) =>
    downloadFile(
      `config-api/printout/timesheetDetailed`,
      {
        companies: companies.map((c) => `${c.key}|${c.value}`),
        period,
        detailed,
      },
      true,
      getOutputType(OutputType.Pdf),
    )

  return {
    getPdf,
    getOutputFile,
    getActiveDriversReport,
    getSynchronizationReport,
    getAuditReport,
    getPdfFromDates,
    getCompanyDataReport,
    getTimesheetReport,
    getTimesheetDetailedReport,
    getDemoReport,
    getRealIncomeReport,
  }
}

export default {
  create,
}
